module.exports = __webpack_public_path__ + "5a6c80720d08e492ad7c5ca2e1eac63c.svg";